import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Input from '../../../components/input';
import PhoneNumberInput from '../../../components/PhoneNumberInput';
import Button from '../../../components/button';
import '../../../styles/Issue.css';
import { useSelector, useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { WarehouseSchema } from '../../../utils/Schema';
import { createWarehouse } from '../../../store/Slices/PartVendorSlice';
import { successNotify, errorNotify } from '../../../utils/toast';
import GoogleMapInput from '../../../components/GoogleMapInput';

const AddWarehouse = ({ onSave, onCancel }) => {
    const dispatch = useDispatch();

    // Initial values for Formik
    const initialValues = {
        name: '',
        address: {
            warehouse_point: '',
            warehouse_latitude: '',
            warehouse_longitude: ''
        },
        pocName: '',
        pocContact: '',
        pocEmail: '',
    };

    const { createWarehouseLoading } = useSelector((state) => state.partVendors);
    const requiredStar = <span className="required_star">*</span>;

    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={WarehouseSchema}
                enableReinitialize={true}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        const payload = {
                            name: values.name,
                            location: values.address?.warehouse_point,
                            lat: values.address?.warehouse_latitude,
                            lng: values.address?.warehouse_longitude,
                            poc_name: values.pocName,
                            poc_contact: values.pocContact,
                            poc_email: values.pocEmail,
                            status: 'active'
                        };

                        await dispatch(createWarehouse(payload)).unwrap();
                        successNotify("Warehouse created successfully");
                        onSave(values);
                    } catch (err) {
                        errorNotify(err);
                    } finally {
                        setSubmitting(false);
                    }
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue
                }) => (
                    <form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={12} className="mb-2">
                                <Input
                                    label={<>Warehouse Name {requiredStar}</>}
                                    placeholder="Enter Warehouse Name"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.name}
                                    touched={touched.name}
                                    required={false}
                                />
                            </Col>
                            <Col md={12} className="mb-2">
                                <GoogleMapInput
                                    label={<>Address {requiredStar}</>}
                                    name="address"
                                    value={values.address}
                                    setFieldValue={setFieldValue}
                                    onBlur={handleBlur}
                                    error={errors.address}
                                    touched={touched.address}
                                    fieldPrefix="warehouse"
                                    required={false}
                                />
                            </Col>
                            <Col md={12} className="mb-2">
                                <Input
                                    label={<>POC Name {requiredStar}</>}
                                    placeholder="Enter POC Name"
                                    name="pocName"
                                    value={values.pocName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.pocName}
                                    touched={touched.pocName}
                                    required={false}
                                />
                            </Col>
                            <Col md={12} className="mb-2">
                                <PhoneNumberInput
                                    label={<>POC Phone Number {requiredStar}</>}
                                    placeholder="923XXXXXXXXX"
                                    name="pocContact"
                                    value={values.pocContact}
                                    setFieldValue={setFieldValue}
                                    onBlur={handleBlur}
                                    error={errors.pocContact}
                                    touched={touched.pocContact}
                                    required={false}
                                />
                            </Col>
                            <Col md={12} className="mb-2">
                                <Input
                                    label={<>POC Email Address {requiredStar}</>}
                                    placeholder="Enter POC Email Address"
                                    name="pocEmail"
                                    value={values.pocEmail}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.pocEmail}
                                    touched={touched.pocEmail}
                                    required={false}
                                />
                            </Col>

                            <Col md={12}>
                                <Button
                                    cancelBtn={onCancel}
                                    submitBtn={handleSubmit}
                                    submitText={createWarehouseLoading ? "Submitting..." : "Submit"}
                                    type="submit"
                                    loading={createWarehouseLoading}
                                    disabled={createWarehouseLoading}
                                />
                            </Col>
                        </Row>
                    </form>
                )}
            </Formik>
        </div>
    );
};

export default AddWarehouse;
